var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('img',{attrs:{"src":require("@/assets/img/404.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t("v210801.page-is-lost")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }